import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rich-textarea-input',
  templateUrl: './rich-textarea-input.component.html',
  styleUrl: './rich-textarea-input.component.scss'
})
export class RichTextareaInputComponent implements OnInit {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<string>();

  ngOnInit(): void {
    // console.log(this.value)
  }

  updateValue(value: string) {
    this.value = value;
    this.valueChange.emit(value);
  }
}
